import { createRoot } from 'react-dom/client'
import App from './App.js'
import './index.css'
import { initSentry } from './lib/sentry'
import { applyTheme, getStoredTheme } from './hooks/useTheme'
import { applyAccent, getStoredAccent } from './hooks/useAccentColor'

initSentry()
applyTheme(getStoredTheme())
applyAccent(getStoredAccent())


createRoot(document.getElementById("root")!).render(
    <App />
);
